exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-white {\n  color: #fff;\n}\n", ""]);

